// CSS Unit reference: https://www.w3schools.com/cssref/css_units.asp
// Absolute Lengths
export type CentimeterValue = string;
export type MillimeterValue = string;
export type InchValue = string;
export type PixelValue = string;
export type PointValue = string;
export type PicaValue = string;

// Relative Lengths
export type PercentValue = string;
export type ElementValue = string;
export type RootElementValue = string;
export type ViewportWidthValue = string;
export type ViewportHeightValue = string;
export type ViewportMinValue = string;
export type ViewportMaxValue = string;

export type CSSLengthUnit =
  | CentimeterValue
  | MillimeterValue
  | InchValue
  | PixelValue
  | PointValue
  | PicaValue
  | PercentValue
  | ElementValue
  | RootElementValue
  | ViewportWidthValue
  | ViewportHeightValue
  | ViewportMinValue
  | ViewportMaxValue;

export const cssLengthUnits = {
  // Absolute Lengths
  cm: (value: number): CentimeterValue => `${value}cm`,
  mm: (value: number): MillimeterValue => `${value}mm`,
  in: (value: number): InchValue => `${value}in`,
  px: (value: number): PixelValue => `${value}px`,
  pt: (value: number): PointValue => `${value}pt`,
  pc: (value: number): PicaValue => `${value}pc`,

  // Relative Lengths
  em: (value: number): ElementValue => `${value}em`,
  rem: (value: number): RootElementValue => `${value}rem`,
  vw: (value: number): ViewportWidthValue => `${value}vw`,
  vh: (value: number): ViewportHeightValue => `${value}vh`,
  vmin: (value: number): ViewportMinValue => `${value}vmin`,
  vmax: (value: number): ViewportMaxValue => `${value}vmax`,
  pct: (value: number): PercentValue => `${value}%`,
};
